import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { CurrentUserResponseData } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import mergeObjects from '../../helper/mergeObjects';

export type CurrentUserState = {
  currentUser: CurrentUserResponseData | undefined;
};

const initialState: CurrentUserState = {
  currentUser: undefined,
};

const persistWhitelist = ['currentUser'];

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    currentUserUpdated: (state, action: PayloadAction<{ user?: CurrentUserResponseData }>) => {
      const { user } = action.payload;
      state.currentUser = mergeObjects(state.currentUser, user);
    },
  },
});

export { persistWhitelist as currentUserPersistWhitelist };
export const { currentUserUpdated } = currentUserSlice.actions;
export default currentUserSlice.reducer;
